import React, { useEffect, useCallback } from 'react';
import { ReportContainer, Select, RadioGroup, Graph, StickyTable, AutoComplete, Icon } from 'components';
import { useReport } from 'store/report';
import { useSetState } from 'utils/hooks/useSetState';
import { useModal } from 'utils/hooks/useModal';
import { SELECTLIST, RADIOLIST } from 'constants/index';
import { useFormatterReport } from 'utils/hooks/useFormatterReport';

import { UiGraphRemind } from './ReliabilityOfGeneralExaminationPapers.style';

/**
 * 全科試卷信度
 */

export const ReliabilityOfGeneralExaminationPapers = () => {
  const {
    formatterGraphData,
    formatterTableData,
  } = useFormatterReport();
  const { setModal } = useModal();
  const [{
    educationSelected,
    schoolYear,
    examType,
    grade,
    group,
    remind,
  }, setState] = useSetState({
    educationSelected: '',
    schoolYear: '',
    examType: '',
    grade: '',
    group: '',
    remind: '',
  });

  const [{
    selections,
    reliability
  }, {
    getReportSeletions,
    getReliability,
  }] = useReport();

  const onChangeSchool = value => {
    setState({
      group: value.school,
      schoolName: value.schoolName
    });
  };

  const onChangeHandler = value => {
    setState({
      ...value
    });
  };

  const selectGroup = useCallback(() => {
    if (Object.entries(selections).length === 0) return (<div>Loading...</div>);
    const {
      education,
      schoolYear: schoolYearOptions,
      grade: gradeOptions,
      examType: examTypeOptions,
    } = selections;
    //縣籍
    if (education) {
      return (
        <>
          <Select
            label={SELECTLIST.EDUCATION.label}
            options={education}
            selectName="educationSelected"
            onChange={onChangeHandler}
          />
          <Select
            label={SELECTLIST.SCHOOLYEAR.countyLabel}
            options={schoolYearOptions}
            selectName="schoolYear"
            onChange={onChangeHandler}
          />
          <Select
            label={SELECTLIST.EXAMTYPE.label}
            options={examTypeOptions}
            selectName="examType"
            onChange={onChangeHandler}
          />
        </>
      );
    }
    if (gradeOptions) {
      return (
        <>
          <Select
            label={SELECTLIST.SCHOOLYEAR.countyLabel}
            options={schoolYearOptions}
            selectName="schoolYear"
            onChange={onChangeHandler}
          />
          <Select
            label={SELECTLIST.GRADE.label}
            options={gradeOptions}
            selectName="grade"
            onChange={onChangeHandler}
          />
          <Select
            label={SELECTLIST.EXAMTYPE.label}
            options={examTypeOptions}
            selectName="examType"
            onChange={onChangeHandler}
          />
        </>
      );
    }
    if (examTypeOptions && schoolYearOptions) {
      return (
        <>
          <Select
            label={SELECTLIST.SCHOOLYEAR.countyLabel}
            options={schoolYearOptions}
            selectName="schoolYear"
            onChange={onChangeHandler}
          />
          <Select
            label={SELECTLIST.EXAMTYPE.label}
            options={examTypeOptions}
            selectName="examType"
            onChange={onChangeHandler}
          />
        </>
      );
    }
    return (
      <div>Loading...</div>
    );
  }, [selections]);

  const filterGroup = () => {
    const { education, } = selections;
    const { schoolName, className: groupList } = reliability;
    if (education) {
      if (Object.keys(schoolName).length === 0) return;
      const schoolOptions = Object.entries(schoolName).map(([key, value]) => {
        return {
          name: value,
          value: key
        };
      });
      return (
        <AutoComplete
          list={schoolOptions}
          label="選擇學校"
          name="school"
          onChange={onChangeSchool}
        />
      );
    }
    if (groupList && Object.entries(groupList).length > 0) {
      if (typeof (groupList) === 'string') return null;
      const nextGroupList = Object.entries(groupList).map(([key, value]) => {
        return {
          name: value,
          value: key
        };
      });
      return (
        <RadioGroup
          name="group"
          data={nextGroupList}
          onChange={onChangeHandler}
          label={RADIOLIST.CLASS.label}
        />
      );
    }
    return null;
  };



  const dataGroup = useCallback(() => {
    const { education } = selections;
    if (Object.keys(reliability.title).length === 0) return null;
    if (group === '') return;
    let reportTypeString = '';
    let reportRoleString = '';
    let groupList = {};
    const { title, schoolName, className, dataList } = reliability;
    if (education) {
      reportTypeString = '信度';
      reportRoleString = '全縣';
      groupList = schoolName;
    } else if (className) {
      reportTypeString = '信度';
      reportRoleString = '全校';
      groupList = className;
    }
    const formatData = {
      reportData: reliability,
      title,
      groupList,
      dataList,
      reportTypeString,
      reportRoleString,
      group
    };
    const { data, pv, uv } = formatterGraphData(formatData);
    const nextTableData = formatterTableData({
      ...formatData,
      groupName: education ? '學校' : '班級'
    });
    return (
      <>
        <Graph.BarLine data={data} pv={pv} uv={uv} />
        <UiGraphRemind
          onClick={() => {
            setModal({
              title: '信度提示',
              html: '<p>信度指的是在考卷中，每個題目的概念或知識點是否能準確的測量到相同的概念的數值，信度數值越高，代表此考卷優良試題越多。</p>',
              showCancelButton: false,
              confirmEvent: () => { },
            });
          }}
        >
          <Icon name='error' color='#f00' />信度提示
        </UiGraphRemind>
        <StickyTable.FixedTitle
          schema={nextTableData.tableSchema}
          data={nextTableData.data}
        />
      </>
    );
  }, [group, reliability.title]);

  const teacherDataGroup = useCallback(() => {
    if (Object.keys(reliability.classDiscrimination).length === 0) return null;
    const { classDiscrimination, schoolDiscrimination, header, className } = reliability;
    const tableSchema = ['', ...header.map(item => item.name)];
    const allSubjectRate = [];
    const classSUbjectRate = [];
    const graphData = [];
    const uv = className;
    const pv = '全校信度';

    header.forEach(item => {
      const allSubjectValue = schoolDiscrimination[item.value];
      const classSubjectValue = classDiscrimination[item.value];
      allSubjectRate.push(`${allSubjectValue}%`);
      classSUbjectRate.push(`${classSubjectValue}%`);
      graphData.push({
        name: item.name,
        [uv]: classSubjectValue,
        [pv]: allSubjectValue,
      });
    });

    const newTableData = [
      {
        catelogey: '全校全科試卷信度',
        list: allSubjectRate
      },
      {
        catelogey: className,
        list: classSUbjectRate
      }
    ];
    return (
      <>
        <Graph.BarLine data={graphData} pv={pv} uv={uv} />
        <UiGraphRemind
          onClick={() => {
            setModal({
              title: '信度提示',
              html: '<p>信度指的是在考卷中，每個題目的概念或知識點是否能準確的測量到相同的概念的數值，信度數值越高，代表此考卷優良試題越多。</p>',
              showCancelButton: false,
              confirmEvent: () => { },
            });
          }}
        >
          <Icon name='error' color='#f00' />信度提示
        </UiGraphRemind>
        <StickyTable.FixedTitle schema={tableSchema} data={newTableData} headerCount={1} canSort={false} />
      </>
    );
  }, [reliability.classDiscrimination]);

  useEffect(() => {
    const payload = {
      reportType: 'Reliability'
    };
    getReportSeletions(payload);
  }, []);

  useEffect(() => {
    const { education, grade: gradeOptions } = selections;
    if (education) {
      setState({
        remind: '※ 點選學校名稱會以藍色折線圖呈現於圖表'
      });
      if (educationSelected && schoolYear && examType) {
        const payload = {
          education: educationSelected,
          schoolYear,
          examType,
        };
        getReliability(payload);
      }
    } else if (gradeOptions) {
      setState({
        remind: '※ 點選班級名稱會以藍色折線圖呈現於圖表'
      });
      if (schoolYear && examType && grade) {
        const payload = {
          grade,
          schoolYear,
          examType,
        };
        getReliability(payload);
      }
    } else {
      if (schoolYear && examType) {
        const payload = {
          schoolYear,
          examType,
        };
        getReliability(payload);
      }
    }
  }, [educationSelected, schoolYear, examType, grade]);

  return (
    <ReportContainer
      title="全科試卷信度"
      remind={remind}
      selectGroup={selectGroup()}
      radioChildren={filterGroup()}
    >
      {Object.keys(reliability.title).length > 0 && dataGroup()}
      {Object.keys(reliability.classDiscrimination).length > 0 && teacherDataGroup()}
    </ReportContainer>
  );
};
